import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from './request.service';
import { UploadService } from './upload-parts/upload.service';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})

export class ExportService {

	private header: HttpHeaders;

	constructor(
		private http: HttpClient) {
	}

	getContentExport(category?: string, format?: any, search?: object): Observable<any> {		
		return this.http.post(`${environment.apiURL}/contents/export?category=${category}&format=${format}`
		, search, {observe: 'response', responseType: 'blob' });  				
	}	

	postExportContents(onlyPublished?: boolean, format?: any): Observable<any> {		
		return this.http.post(`${environment.apiURL}/contents/export-contents?onlyPublished=${onlyPublished}&format=${format}`, null, 
		{observe: 'response', responseType: 'blob' });
	}
}
